import CopyToClipboard from "../../../components/BuilderComponents/CopyToClipboard";
import "../monitor.css";

const UserLogRow = ({ log }) => {
  const userEmail = log.user_email || "-";
  const userId = log.user_id || "-";

  return (
    <tr>
      <td>
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <span
            style={{
              maxWidth: "220px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            }}
            title={userEmail}
          >
            {userEmail}
          </span>
          {log.user_email && <CopyToClipboard text={log.user_email} successMessage="User email" />}
        </div>
      </td>

      <td>
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <span
            style={{
              maxWidth: "220px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            }}
            title={userId}
          >
            {userId}
          </span>
          {log.user_id && <CopyToClipboard text={log.user_id} successMessage="User ID" />}
        </div>
      </td>

      <td>
        <span className={`status_pill ${log.type || "default"}`}>{log.type || "N/A"}</span>
      </td>

      <td>
        {log.created_at
          ? new Date(log.created_at).toLocaleString("en-IN", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true
            })
          : "-"}
      </td>
    </tr>
  );
};

export default UserLogRow;
